import { IntegrationModuleListItem } from 'components/Integrations/components/IntegrationModuleListItem';
import React from 'react';
import stripeSrc from 'images/stripe_logo.png';

export const StripeIntegrationListItem = () => (
  <IntegrationModuleListItem iconSrc={stripeSrc} content="Stripe Payments" />
);
